import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { Layout, RequireAuth } from './components/Layout';
import { Loading } from './components/common';
import { AuditPage, UsersPage } from './pages/AdminPages';
import { AssessmentPage } from './pages/AssessmentPage';
import { LoginPage, RegisterPage, SsoCallbackPage } from './pages/AuthPages';
import { ComparePage } from './pages/ComparePage';
import { DashboardPage } from './pages/DashboardPage';
import { LiveSessionPage } from './pages/LiveSessionPage';
import { ProfilePage } from './pages/ProfilePage';
import { ScenarioEditorPage } from './pages/ScenarioEditorPage';
import { ScenariosPage } from './pages/ScenariosPage';
import { SessionDetailPage, SessionsPage } from './pages/SessionsPages';
import { StatisticsPage } from './pages/StatisticsPage';
import { VoiceProfilesPage } from './pages/VoiceProfilesPage';

const ApiDocsPage = lazy(() => import('./pages/ApiDocsPage'));

function NotFound() {
  const { t } = useTranslation();
  return <h1>{t('common.notFound')}</h1>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<SsoCallbackPage />} />
      {/* Публичная документация API для интеграторов — без входа. */}
      <Route
        path="/developers"
        element={
          <main id="main" className="public-docs">
            <Suspense fallback={<Loading />}>
              <ApiDocsPage />
            </Suspense>
          </main>
        }
      />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="live" element={<LiveSessionPage />} />
        <Route path="live/:id" element={<LiveSessionPage />} />
        <Route path="assess" element={<AssessmentPage />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="sessions/:id" element={<SessionDetailPage />} />
        <Route path="scenarios" element={<ScenariosPage />} />
        <Route path="scenarios/:id" element={<ScenarioEditorPage />} />
        <Route path="voice-profiles" element={<VoiceProfilesPage />} />
        <Route path="statistics" element={<StatisticsPage />} />
        <Route path="compare" element={<ComparePage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route
          path="api-docs"
          element={
            <Suspense fallback={<Loading />}>
              <ApiDocsPage />
            </Suspense>
          }
        />
        <Route
          path="admin/users"
          element={
            <RequireAuth role="admin">
              <UsersPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/audit"
          element={
            <RequireAuth role="admin">
              <AuditPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
